import styled from '@emotion/styled';
import { TabletWidth } from '../../../../global.style';

interface ColWithBackgroundImageStyledProps {
  img: string;
}

export const ColWithBackgroundImageStyled = styled.div<ColWithBackgroundImageStyledProps>`
  min-height: 100vh;
  width: 50%;
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: end;
  margin-top: 50px;
  margin-left: 80px;
  position: relative;
  z-index: 1;
`;
